import { useState } from 'react';
import style from './index.module.scss';

import {
	HOLDING_PAGE_TITLE,
	HOLDING_PAGE_CONTENT,
	HOLDING_PAGE_BUTTON_TEXT,
	HOLDING_PAGE_BUTTON_LINK,
	CDN_URL,
} from '@lib/constants';
import Btn from '@components/Btn';

export default function HoldingPage({}) {
	const handleClick = () => {
		window.location.href = HOLDING_PAGE_BUTTON_LINK;
	};

	return (
		<section className={`HoldingPage__component ${style.component}`}>
			<div className={`HoldingPage__container ${style.container}`}>
				<img
					src={CDN_URL + '/logo-header.webp'}
					alt="Prospectus logo"
					width={200}
					style={{ marginInline: 'auto' }}
					className={`${style.logo} mb-5`}
				/>
				<h1>{HOLDING_PAGE_TITLE}</h1>
				<p>{HOLDING_PAGE_CONTENT}</p>
				{HOLDING_PAGE_BUTTON_LINK && (
					<Btn onClick={handleClick} customClass={['outline', 'outline--home', 'mt-5']}>
						{HOLDING_PAGE_BUTTON_TEXT}
					</Btn>
				)}
			</div>
		</section>
	);
}
